import { TableCell, TableRow } from '@mui/material';
import { ForetagAdress, GeneralAddress } from '../ForetagAdress/ForetagAdress';

interface ForetagAddressRowProps {
  address: GeneralAddress;
  title: string;
}

export const ForetagAddressRow: React.FC<ForetagAddressRowProps> = ({
  address,
  title,
}) =>
  address ? (
    <TableRow>
      <TableCell>{title}</TableCell>
      <TableCell>
        <ForetagAdress address={address} />
      </TableCell>
    </TableRow>
  ) : (
    <></>
  );
